type SigningTokenResponse = { signingToken: string };

export type SigningRequiredResponse<R = void> = SigningTokenResponse | R;

export function requiresSigning<T = any>(
	val: SigningRequiredResponse<T>,
): val is SigningTokenResponse {
	// biome-ignore lint/suspicious/noPrototypeBuiltins: Should use Object.hasOwn instead but TS doesn't like it.
	return Object.prototype.hasOwnProperty.call(val, "signingToken");
}
